export default __webpack_public_path__ + "static/media/bg_1.412c7b49.JPG";